// Levels are matched by word prefix, so new names ("Kinder 3", "Primary Plus") group without code changes.
// Order within the named ladder; the first match wins.
const NAMED_LADDER = [
  /\bacc\w*\s+sco/,
  /\bacc\w*\s+kni/,
  /\bacc\w*\s+cha/,
  /\bacc/,
  /\bsil/,
  /\bgol/,
  /\bpla/,
  /\bprem/,
  /\bdia/,
  /\bgla/,
]

const TIER = { KINDY: 0, STARTER: 1, NAMED: 2, PRIMARY: 3, OTHER: 4 }
const BANDS = ["low", "medium", "high"]

const tierOf = (text) => {
  if (/\bkin|\bpre[\s-]?pri/.test(text)) return TIER.KINDY
  if (/\bstar/.test(text)) return TIER.STARTER
  if (NAMED_LADDER.some((re) => re.test(text))) return TIER.NAMED
  if (/\bpri/.test(text)) return TIER.PRIMARY
  return TIER.OTHER
}

const buildSortKey = (row) => {
  const level = String(row.classLevel ?? "").trim().toLowerCase()
  const koc = String(row.koc ?? "").trim().toLowerCase()
  // A level like "1A" says nothing about the tier; the KOC ("Kindergarten") does.
  const text = tierOf(level) !== TIER.OTHER ? level : `${koc} ${level}`
  const code = level.match(/(\d+(?:\.\d+)?)\s*([a-z])?(?![a-z])/)
  const ladder = NAMED_LADDER.findIndex((re) => re.test(text))
  const band = BANDS.findIndex((name) => new RegExp(`\\b${name}\\b`).test(text))
  // "48/96" -> 48. Classes with no hours go last in their group.
  const hours = parseFloat(row.lessonStudied)

  return {
    tier: tierOf(text),
    ladder,
    band,
    number: code ? Number(code[1]) : -1,
    letter: code?.[2] ?? "",
    hours: Number.isNaN(hours) ? Infinity : hours,
    name: String(row.className ?? ""),
    text,
  }
}

const compareKeys = (a, b) => {
  const byNumbers =
    a.tier - b.tier ||
    (a.tier === TIER.OTHER ? a.text.localeCompare(b.text) : 0) ||
    a.ladder - b.ladder ||
    a.band - b.band ||
    a.number - b.number ||
    a.letter.localeCompare(b.letter)
  if (byNumbers) return byNumbers
  if (a.hours !== b.hours) return a.hours < b.hours ? -1 : 1
  return a.name.localeCompare(b.name)
}

export function sortClassSituationRows(rows) {
  return rows
    .map((row) => ({ row, key: buildSortKey(row) }))
    .sort((a, b) => compareKeys(a.key, b.key))
    .map((item) => item.row)
}
